<template>
    <v-card outlined class="primary white--text">
        <div class="primary darken-1 pa-4">
            <div class="body-2 font-weight-medium">
                <v-icon small color="amber" left @click="$emit('cancel')">fa-arrow-left</v-icon>
                <span style="opacity:.7">My goals in {{lapse}} years</span>
            </div>

            <div class="pl-5 my-1">
                <v-divider></v-divider>
            </div>

            <div class="ml-5">
                <div class="caption font-weight-medium">GOAL TRACKING:</div>
                <div class="title mt-n1">
                    <v-icon size="12px" color="white" class="mr-1 ml-1">fa-minus</v-icon>
                    {{goal.item.goal}}
                </div>
            </div>
        </div>

        <template v-if="loaded">
            <!-- RESOURCES I HAVE -->
            <v-card-text class="pt-3 px-6 pb-7 white--text">

                <div class="text-center">
                    <v-chip color="primary lighten-1" class="mt-4 mb-4">
                        Resources I have to accomplish my goal:
                    </v-chip>
                </div>

                <div v-for="(item, index) in resourcesYes['g'+goal.index]" :key="item.id">
                    <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-start">
                            <div class="title mr-2">{{index+1}}.</div>
                            <div v-if="!validateIsEmpty(item)">
                                <div class="title font-weight-regular">{{item}}</div>
                            </div>
                            <div v-else>
                                <div class="subtitle-1 mt-1 font-weight-medium" style="opacity:.4">PENDING...</div>
                            </div>
                        </div>

                        <!-- <v-btn class="white primary--text" :disabled="validateIsEmpty(item)">Track</v-btn> -->
                    </div>

                    <v-divider class="my-4" v-if="index<resourcesYes['g'+goal.index].length-1"></v-divider>
                </div>

                <v-divider class="mt-6"></v-divider>

                <div class="mt-6 text-center">
                    <v-btn outlined class="white--text" @click="$emit('editYes')">
                        Edit resources I have
                    </v-btn>
                </div>
            </v-card-text>

            <!-- RESOURCES I DONT HAVE -->
            <v-card-text class="pt-3 px-6 pb-7 white--text">
                <div class="text-center">
                    <v-chip color="primary lighten-1" class="mb-6">
                        Resources <span class="mx-1 font-weight-medium" style="text-decoration: underline">I do not have</span> to accomplish my goal:
                    </v-chip>
                </div>

                <div v-for="(item, index) in resourcesNo['g'+goal.index]" :key="item.id">
                    <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-start">
                            <div class="title mr-2">{{index+1}}.</div>
                            <div v-if="!validateIsEmpty(item)">
                                <div class="title font-weight-regular">{{item}}</div>
                            </div>
                            <div v-else>
                                <div class="subtitle-1 mt-1 font-weight-medium" style="opacity:.4">PENDING...</div>
                            </div>
                        </div>

                        <v-btn class="white primary--text" :disabled="validateIsEmpty(item)" @click="$emit('track', {item:item, index:index})">Track</v-btn>
                    </div>

                    <v-divider class="my-4" v-if="index<resourcesNo['g'+goal.index].length-1"></v-divider>
                </div>

                <v-divider class="mt-6"></v-divider>

                <div class="mt-6 text-center">
                    <v-btn outlined class="white--text" @click="$emit('editNo')">
                        Edit resources I do not have
                    </v-btn>
                </div>
            </v-card-text>

            <div class="text-center mt-1 mb-8">
                <v-btn class="white primary--text" @click="$emit('cancel')">
                    <v-icon small color="primary" left>fa-angle-left</v-icon>
                    Back to goals
                </v-btn>
            </div>
        </template>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        resourcesYes: {},
        resourcesNo: {},
    }),
    props: ['goals', 'lapse', 'goal'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.resourcesYes['g'+this.goal.index] = ['', '', '', '', '']
            this.resourcesNo['g'+this.goal.index] = ['', '', '']

            if (this.goals['t'+this.lapse].resourcesYes && this.goals['t'+this.lapse].resourcesYes['g'+this.goal.index]) {
                _.merge(this.resourcesYes['g'+this.goal.index], this.goals['t'+this.lapse].resourcesYes['g'+this.goal.index]);
            }

            if (this.goals['t'+this.lapse].resourcesNo && this.goals['t'+this.lapse].resourcesNo['g'+this.goal.index]) {
                _.merge(this.resourcesNo['g'+this.goal.index], this.goals['t'+this.lapse].resourcesNo['g'+this.goal.index]);
            }

            this.loaded = true;
        }
    }
}
</script>